<template>
  <el-dialog
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
    class="customDialogForm"
  >
    <el-form ref="versionform" :rules="rules" :model="version">
      <el-form-item prop="versionAlias" label="版本别名" :label-width="formLabelWidth">
        <el-input v-model="version.appVersionAlias" autocomplete="off"></el-input>
      </el-form-item>
      <div style="display:flex">
      <el-form-item prop="enable" label="可用性" :label-width="formLabelWidth">
        <el-switch v-model="version.enable" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      <el-form-item prop="is_plugin" label="作为插件" :label-width="formLabelWidth" style="margin-left:20px">
        <el-switch v-model="version.is_plugin" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>
      </div>
      <el-form-item prop="description" label="版本描述" :label-width="formLabelWidth">
        <el-input style="min-height: 200px;" :rows="8" type="textarea" v-model="version.desc" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { updateAppVersion } from '@/api/app';
import { errorHandle } from '@/utils/error';
export default {
  name: 'EditAppVersion',
  props: {
    version: {
      type: Object,
      default: () => {
        return {
          versionAlias: '',
          enable: false,
          description: '',
          is_plugin: false
        }
      }
    },
    appID: String,
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    return {
      rules: {
        enable: [],
        versionAlias: [
          { min: 2, max: 255, message: '分类名称必须大于1个字符', trigger: 'blur' }
        ],
        description: [
          { min: 2, max: 255, message: '描述最多255个字符', trigger: 'blur' }
        ]
      },
      app: {},
      title: '更新版本信息',
      formLabelWidth: '80px',
      Loading: false
    };
  },
  created() {
  },
  methods: {
    submit() {
      this.Loading = true;
      this.$refs.versionform.validate(valid => {
        if (valid) {
          updateAppVersion({
            marketID: this.marketID,
            appID: this.appID,
            version: this.version.appVersion,
            enable: this.version.enable,
            description: this.version.desc,
            versionAlias: this.version.appVersionAlias,
            is_plugin: this.version.is_plugin
          })
            .then(res => {
              this.Loading = false;
              this.onSuccess && this.onSuccess()
            })
            .catch(err => {
              this.Loading = false;
              errorHandle(err)
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.versionform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/storeManage/appManage/components/editAppVersion.vue